import * as types from './mutations-types';

const initialState = {
  phoneNumberToValidate: '',
  tokenType: '',
  isSending: false,
  error: null,
};

const actions = {
  setPhoneNumberToValidate({ commit }, phoneNumber) {
    commit(types.PHONE_TOKEN_MODAL_SET_PHONE_NUMBER_TO_VALIDATE, phoneNumber);
  },

  setTokenType({ commit }, tokenType) {
    commit(types.PHONE_TOKEN_MODAL_SET_TOKEN_TYPE, tokenType);
  },
};

const mutations = {
  [types.PHONE_TOKEN_MODAL_SET_PHONE_NUMBER_TO_VALIDATE](state, phoneNumber) {
    state.phoneNumberToValidate = phoneNumber;
  },

  [types.PHONE_TOKEN_MODAL_SET_TOKEN_TYPE](state, tokenType) {
    state.tokenType = tokenType;
  },

  [types.PHONE_TOKEN_MODAL_SET_IS_SENDING](state, value) {
    state.isSending = value;
  },

  [types.PHONE_TOKEN_MODAL_SET_ERROR](state, error) {
    state.error = error;
  },
};

export default {
  namespaced: true,
  state: initialState,
  actions,
  mutations,
};
